import { PetType } from 'constants/pet-type';
import { InputProductType, WetFoodTagValues } from 'interfaces/api-input/input-product-type';
import { CatProfile, DogProfile } from 'types/pet-profile';

export const DEFAULT_CUSTOMER_ID = 'guest';

export const INITIAL_FOOD_TYPES = [
  InputProductType.DryFood,
  InputProductType.WetFood,
  InputProductType.Snacks,
];

export const INITIAL_DOG_FOOD_TYPES = [...INITIAL_FOOD_TYPES, InputProductType.Barf];

const INITIAL_BASE = {
  selectedAge: undefined,
  selectedAllergies: [],
  selectedNeeds: [],
  lastTouched: undefined,
  name: '',
  selectedWeight: undefined,
  updatedAt: undefined,

  // calorie calc specific
  dateOfBirth: undefined,
  bodyCondition: undefined,
  neutered: undefined,
  activityLevel: undefined,
  kcalUpdatedAt: undefined,
  dailyKcal: undefined,
  hasSpecialNeeds: undefined,
};

export const INITIAL_DOG_STATE: DogProfile = {
  ...INITIAL_BASE,
  selectedBreed: undefined,
  petType: PetType.Dog,
  id: `local_${crypto.randomUUID()}`,
  selectedFoodTypes: INITIAL_DOG_FOOD_TYPES,
};

export const INITIAL_CAT_STATE: CatProfile = {
  ...INITIAL_BASE,
  selectedWetFoodTypes: [WetFoodTagValues.Cream, WetFoodTagValues.Pate, WetFoodTagValues.Sauce],
  selectedTastePreferences: [],
  selectedDislikedProteins: [],
  petType: PetType.Cat,
  id: `local_${crypto.randomUUID()}`,
  selectedFoodTypes: INITIAL_FOOD_TYPES,
};
